var _style, _desc, _g, _defs, _mask, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 69",
    style: {
      enableBackground: "new 0 0 52 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_1_);fill:url(#Fill-1_1_);}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st4{mask:url(#mask-5_1_);fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(26.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -26,
    y: -14.7,
    width: 51.7,
    height: 52.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -26,
    y: -14.7,
    width: 51.7,
    height: 52.3,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st1",
    points: "-26,-15.8 25.7,-15.8 25.7,37.8 -26,37.8  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -669.2989,
    y1: 397.3243,
    x2: -668.3218,
    y2: 396.3243,
    gradientTransform: "matrix(51.6889 0 0 -52.2923 34569.8008 20762.3516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E96401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD4D7C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st2",
    d: "M24.6,36.4V9.7c0-4-3.4-7.3-7.6-7.3H17v34H24.6z M-17.2,2.4L-17.2,2.4c-4.2,0-7.6,3.2-7.6,7.2 v26.8h7.6V2.4z M-2.1,8.8h13V2.4h-13V-10h-1.5c-3.5,0-6.4,2.8-6.4,6.2v0.1v6.3l0,20.5c0,1.5,0.1,2.9,0.4,4.4 c0.7,3.8,2.6,7,6.4,8.7c4.8,2.1,9.1,1.9,14,0.3v-7c0,0-2.6,1.1-6.4,1.1c-0.5,0-1.1,0-1.6-0.1c-2.5-0.5-4.2-2-4.7-4.7 c-0.1-0.8-0.2-1.5-0.2-2.3V8.8z M15.8-10.2c0,2.6,2.1,4.7,4.9,4.7c2.8,0,5-2,5-4.7c0-2.6-2.1-4.6-4.9-4.6 C18-14.8,15.8-12.8,15.8-10.2L15.8-10.2z M-21.1-14.7c2.8,0,5,2,5,4.6c0,2.6-2.2,4.7-5,4.6c-2.8,0-4.9-2-4.9-4.6 C-26-12.7-23.9-14.7-21.1-14.7L-21.1-14.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(31.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -26,
    y: -15.7,
    width: 18.8,
    height: 9.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -26,
    y: -15.7,
    width: 18.8,
    height: 9.3,
    id: "mask-5_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-4_1_",
    className: "st1",
    points: "-26,-15.7 -7.2,-15.7 -7.2,-6.4 -26,-6.4  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st4",
    d: "M-9.3-13.8h-1.3l1.3-1.9h1.6L-9.3-13.8z M-10.4-6.4c-0.6,0-1.2-0.2-1.5-0.7 c-0.4-0.5-0.6-1.1-0.6-1.8v-4h1.5v3.8c0,0.5,0.1,0.9,0.3,1.1c0.2,0.3,0.5,0.4,0.8,0.4c0.4,0,0.7-0.1,0.9-0.4 c0.2-0.3,0.3-0.6,0.3-1.1V-13h1.5v6.4h-1.3l-0.1-0.7C-8.8-7-9-6.8-9.4-6.7C-9.7-6.5-10-6.4-10.4-6.4L-10.4-6.4z M-16.4-7.5 c0.4,0,0.7-0.1,0.9-0.4c0.3-0.3,0.4-0.6,0.4-1v-0.6c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.6,0-1,0.1-1.4,0.3 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.3,0.1,0.5,0.3,0.7C-16.9-7.6-16.7-7.5-16.4-7.5L-16.4-7.5z M-16.8-6.4c-0.6,0-1.1-0.2-1.5-0.5 c-0.4-0.3-0.6-0.8-0.6-1.3c0-0.7,0.3-1.3,0.8-1.7c0.6-0.4,1.4-0.6,2.4-0.6h0.3c0.1,0,0.2,0,0.3,0c0-0.5-0.2-0.8-0.4-1 c-0.2-0.2-0.6-0.3-1-0.3c-0.6,0-1.2,0.2-1.8,0.5v-1.2c0.6-0.3,1.3-0.5,2-0.5c0.8,0,1.5,0.2,1.9,0.7c0.5,0.5,0.7,1.1,0.7,2v3.8 h-1.2L-15-7.3c-0.2,0.3-0.5,0.5-0.8,0.7C-16.1-6.5-16.4-6.4-16.8-6.4L-16.8-6.4z M-20.5-6.5c-0.7,0-1.2-0.2-1.5-0.5 c-0.3-0.4-0.5-0.9-0.5-1.6v-3.1h-1V-13h1v-1.7h1.5v1.7h1.4v1.2H-21v3c0,0.4,0.1,0.6,0.2,0.8s0.4,0.3,0.7,0.3c0.2,0,0.5,0,0.7-0.1 v1.2C-19.8-6.5-20.1-6.5-20.5-6.5L-20.5-6.5z M-26-6.6h1.5v-8.3H-26V-6.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "_checkout/static/media/logo.a1682d8bda7920ff0533cf2cec4c9aa3.svg";
export { ForwardRef as ReactComponent };